const constants = {
  APISTATUS: "APISTATUS",
  GET_ERROR_REPORT: "GET_ERROR_REPORT",
  LOGOUT: "LOGOUT",
  GET_MASTER_DATA: "GET_MASTER_DATA",
  /**
   * action for Dataset report
   */
  GET_CONTRIBUTION_LIST: "GET_CONTRIBUTION_LIST",
  CLEAR_USER_EVENT: "CLEAR_USER_EVENT",
  GET_DETAILED_REPORT: "GET_DETAILED_REPORT",
  GET_DATASET_SEARCH_VALUES: "GET_DATASET_SEARCH_VALUES",
  GET_BENCHMARK_CONTRIBUTION_LIST: "GET_BENCHMARK_CONTRIBUTION_LIST",
  GET_BENCHMARK_SEARCH_VALUES: "GET_BENCHMARK_SEARCH_VALUES",

  /**
   * action for Dashboard report
   */
  DASHBOARD_DATASETS: "DASHBOARD_DATASETS",
  DASHBOARD_DATASETS_EXPAND: "DASHBOARD_DATASETS_EXPAND",

  /**
   * action for Search report
   */
  GET_MY_REPORT: "GET_MY_REPORT",
  GET_SEARCHED_VALUES: "GET_SEARCHED_VALUES",
  CLEAR_DETAILED_REPORT: "CLEAR_DETAILED_REPORT",
  /**
   * action for search and download report
   */
  GET_SEARCH_OPTIONS: "GET_SEARCH_OPTIONS",
  PAGE_CHANGE: "PAGE_CHANGE",
  ROW_COUNT_CHANGE: "ROW_COUNT_CHANGE",
  BENCHMARK_PAGE_CHANGE: "BENCHMARK_PAGE_CHANGE",
  BENCHMARK_PAGE_COUNT: "BENCHMARK_PAGE_COUNT",
  BENCHMARK_ROW_COUNT_CHANGE: "BENCHMARK_ROW_COUNT_CHANGE",
  SEARCH_PAGE_NO: "SEARCH_PAGE_NO",
  SEARCH_ROW_COUNT_CHANGE: "SEARCH_ROW_COUNT_CHANGE",
  TABLE_PAGINATION_RESET: "TABLE_PAGINATION_RESET",
  SEARCH_TABLE_PAGINATION_RESET: "SEARCH_TABLE_PAGINATION_RESET",
  CONTRIBUTION_TABLE: "CONTRIBUTION_TABLE",
  CLEAR_FILTER: "CLEAR_FILTER",
  CLEAR_BENCHMARK_FILTER: "CLEAR_BENCHMARK_FILTER",
  CONTRIBUTION_BENCHMARK_TABLE: "CONTRIBUTION_BENCHMARK_TABLE",
  CONTRIBUTION_TABLE_VIEW: "CONTRIBUTION_TABLE_VIEW",
  GET_SEARCH_FILTERS: "GET_SEARCH_FILTERS",
  GET_FILTER_CATEGORY: "GET_FILTER_CATEGORY",

  MODEL_ROW_COUNT_CHANGE: "MODEL_ROW_COUNT_CHANGE",
  MODEL_PAGE_CHANGE: "MODEL_PAGE_CHANGE",
  CLEAR_MODEL_FILTER: "CLEAR_MODEL_FILTER",
  GET_SELECTED_FILTER: "GET_SELECTED_FILTER",
  MODEL_CONTRIBUTION_TABLE: "MODEL_CONTRIBUTION_TABLE",
  MODEL_CONTRIBUTION_TABLE_VIEW: "MODEL_CONTRIBUTION_TABLE_VIEW",
  GET_MODEL_CONTRIBUTION_LIST: "GET_MODEL_CONTRIBUTION_LIST",
  SUBMIT_MODEL: "SUBMIT_MODEL",
  SUBMIT_MODEL_SEARCH: "SUBMIT_MODEL_SEARCH",
  GET_BULK_MODEL_SEARCH: "GET_BULK_MODEL_SEARCH",
  CLEAR_BULK_MODEL_SEARCH: "CLEAR_BULK_MODEL_SEARCH",
  UPDATE_SEARCH_FILTER: "UPDATE_SEARCH_FILTER",
  INITIAL_SEARCH_FILTER: "INITIAL_SEARCH_FILTER",
  GET_SEARCHED_LIST: "GET_SEARCHED_LIST",
  SEARCH_FILTER: "SEARCH_FILTER",
  CLEAR_FILTER_MODEL: "CLEAR_FILTER_MODEL",
  GET_MENU_TYPE: "GET_MENU_TYPE",
  GET_MENU_OPTION: "GET_MENU_OPTION",
  TOGGLE_MODEL_STATUS: "TOGGLE_MODEL_STATUS",
  GET_MODEL_SEARCH_VALUES: "GET_MODEL_SEARCH_VALUES",
  GET_MODEL_DETAIL: "GET_MODEL_DETAIL",
  EXPLORE_MODEL_PAGE_NO: "EXPLORE_MODEL_PAGE_NO",
  GET_MODEL_HEALTH_STATUS: "GET_MODEL_HEALTH_STATUS",
  /**
   * action for model benchmark
   */
  RUN_BENCHMARK: "RUN_BENCHMARK",
  SELECT_DATASET: "SELECT_DATASET",
  SELECT_METRIC: "SELECT_METRIC",
  CLEAR_BENCHMARK: "CLEAR_BENCHMARK",
  SEARCH_BENCHMARK: "SEARCH_BENCHMARK",
  BENCHMARK_PAGE_NO: "BENCHMARK_PAGE_NO",
  FILTER_BENCHMARK: "FILTER_BENCHMARK",
  CLEAR_FILTER_BENCHMARK: "CLEAR_FILTER_BENCHMARK",

  /**
   * action for Reaymade
   */
  READYMADE_SEARCH_FILTER: "READYMADE_SEARCH_FILTER",
  INITIAL_READYMADE_FILTER: "INITIAL_READYMADE_FILTER",
  READYMADE_DATASET_SEARCH: "READYMADE_DATASET_SEARCH",

  /**
   * action for Benchmarkmodel
   */

  BENCHMARK_MODEL_SEARCH: "BENCHMARK_MODEL_SEARCH",
  UPDATE_BENCHMARK_FILTER: "UPDATE_BENCHMARK_FILTER",
  INITIAL_BENCHMARK_FILTER: "INITIAL_BENCHMARK_FILTER",
  BENCHMARK_TABLE: "BENCHMARK_TABLE",

  GET_BENCHMARK_DETAILS: "GET_BENCHMARK_DETAILS",
  GET_METRIC_DETAILS: "GET_METRIC_DETAILS",

  /**
   * action for Admin Panel
   */

  GET_USER_DETAILS: "GET_USER_DETAILS",
  UPDATE_USER_DETAILS: "UPDATE_USER_DETAILS",
  UPDATE_USER_STATUS: "UPDATE_USER_STATUS",
  APPLY_SELECTED_FILTER: "APPLY_SELECTED_FILTER",
  SELECT_ADMIN_FILTER: "SELECT_ADMIN_FILTER",
  CLEAR_ADMIN_FILTER: "CLEAR_ADMIN_FILTER",
  SEARCH_USER_DETAILS: "SEARCH_USER_DETAILS",
  TOGGLE_USER_STATUS: "TOGGLE_USER_STATUS",
  GET_API_KEYS: "GET_API_KEYS",
  GET_GLOSSARY_DATA: "GET_GLOSSARY_DATA",
  GET_SPEAKER_DATA: "GET_SPEAKER_DATA",
  ADD_GLOSSARY_DATA: "ADD_GLOSSARY_DATA",
  DELETE_GLOSSARY_DATA: "DELETE_GLOSSARY_DATA",
  MULTIDELETE_GLOSSARY_DATA: "MULTIDELETE_GLOSSARY_DATA",
  FETCH_SPEAKER_DATA: "FETCH_SPEAKER_DATA",
  ENROLL_SPEAKER_DATA: "ENROLL_SPEAKER_DATA",
  VERIFY_SPEAKER_DATA: "VERIFY_SPEAKER_DATA",
  DELETE_SPEAKER_DATA: "DELETE_SPEAKER_DATA",

  /**
   * action for File Upload
   */
  DOCUMENTUPLOAD: "DOCUMENTUPLOAD",

  /**
   * action for Feedback Modal
   */

  SUBMIT_FEEDBACK: "SUBMIT_FEEDBACK",

  /**
   * action for Dataset Metrics
   */
  GET_DATASET_METRICS: "GET_DATASET_METRICS",

  /**
   * action for fetching Transliteraion value
   */

  GET_TRANSLITERATION_TEXT: "GET_TRANSLITERATION_TEXT",
  SET_TRANSLITERATION_TEXT: "SET_TRANSLITERATION_TEXT",
  SET_CURRENT_TEXT: "SET_CURRENT_TEXT",
  CLEAR_TRANSLITERATION_RESULT: "CLEAR_TRANSLITERATION_RESULT",
  GET_TRANSLITERATION_MODEL_ID: "GET_TRANSLITERATION_MODEL_ID",
};

export default constants;
